<template>
  <v-text-field
      rounded="lg"
      :error-messages="error"
      :label="translation(translationList.apartment, 'Apartament')"
      v-model="apartment"
      :rules="apartmentValidationRules"
      name="apartment"
      variant="outlined"
      bg-color="surface"
      :tile="true"
  >
  </v-text-field>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, watch, toRefs } from 'vue';
import { useTranslationStore, translation } from "~/plugins/store/translations";
import type {TranslationList} from "~/types/Utils";

export default defineComponent({
  props: {
    modelValue: String as () => string | null,
    addressIndex: Number as () => number | null,
  },
  setup(props, { emit }) {
    const { modelValue, addressIndex } = toRefs(props);
    const apartment = ref(modelValue.value ? modelValue.value : '');
    const error = ref([]);

    watch(modelValue, (newValue) => {
      apartment.value = newValue;
    });

    watch(apartment, (newValue) => {
      const isValid = validateApartment(newValue);
      if (isValid) {
        emit('update:modelValue', newValue);
      } else {
        emit('update:modelValue', null);
      }
      emit('validation-address-status', { field: Number.isInteger(addressIndex.value) ? `apartment-${addressIndex.value}` : 'apartment', isValid });
    });

    const translationList = ref<TranslationList>({});
    const translationStore = useTranslationStore();

    const apartmentValidationRules = [
      (v: string) => /^[A-Za-z0-9\s]+$/.test(v) || translation(translationList.value.invalid_field, 'Acest câmp este invalid.'),
    ];

    function validateApartment(value: string, showErrors?: boolean): boolean {
      error.value = [];
      if (showErrors) {
        const errors = apartmentValidationRules
            .map(rule => rule(value))
            .filter(result => result !== true) as string[];
        if (errors && errors.length > 0) {
          error.value = errors;
          return false;
        }
      }
      return apartmentValidationRules.every(rule => rule(value) === true);
    }

    onMounted(async () => {
      translationList.value = await translationStore.getTranslations('ro', 'dashboard');
      const isValid = validateApartment(apartment.value);
      emit('validation-address-status', { field: Number.isInteger(addressIndex.value) ? `apartment-${addressIndex.value}` : 'apartment', isValid });

      // Listen for validate events
      window.addEventListener('validate-address', handleValidationEvent);
      window.addEventListener('validate-travel', handleValidationEvent);
    });

    const handleValidationEvent = (data: any) => {
      if (data.detail && data.detail === (Number.isInteger(addressIndex.value) ? `apartment-${addressIndex.value}` : 'apartment')) {
        const isValid = validateApartment(apartment.value, true);
        if (isValid) {
          emit('validation-address-status', { field: Number.isInteger(addressIndex.value) ? `apartment-${addressIndex.value}` : 'apartment', isValid });
        }
      }
    };

    return {
      apartment,
      apartmentValidationRules,
      translationList,
      translation,
      error,
    };
  },
});
</script>

<style scoped>
</style>